export default {
  // currentUser: JSON.parse(localStorage.getItem('currentUser') || 'null')
  currentUUID: null,
  currentGuest: null,
  accessDenied: false,
  currentAccount: null,
  currentAccountId: null,
  loaded: false,
  noNetworkConnection: false,
  stripePublishableKey: false,
  retailCartId: null
}
